<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>退货查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="退货客户编码" prop="dealerCode">
                <el-input v-model="searchform.dealerCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货客户名称" prop="dealerCode">
                <el-input v-model="searchform.dealerCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货单号" prop="orderNum">
                <el-input v-model="searchform.orderNum" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="orderType">
                <el-select v-model="searchform.orderType" placeholder="请选择单据类型">
                  <el-option label="销售退货" :value="1"></el-option>
                  <el-option label="拒收退货" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker style="width:100%" :clearable="false" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col> -->

            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['refund_select']">搜索</el-button>
              <!-- <el-button v-permission="['refund_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>退货查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <af-table-column prop="orderNum" label="退货单号" min-width="160" show-overflow-tooltip></af-table-column>

            <af-table-column prop="creatorAccount" label="制单人账号" min-width="160" show-overflow-tooltip></af-table-column>
            <af-table-column prop="creatorName" label="制单人时间" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="dealerCode" label="退货客户编码" min-width="110" show-overflow-tooltip></af-table-column>
            <af-table-column prop="dealerName" label="退货客户名称" min-width="110" show-overflow-tooltip></af-table-column>
            <af-table-column prop="createTime" label="制单时间" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="depositTime" label="实际退货时间" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="depositPdaUser" label="退货操作人" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="depositWarehouseCode" label="退回出库编码" min-width="100"
              show-overflow-tooltip></af-table-column>
            <af-table-column prop="depositWarehouseName" label="退回仓库名称" min-width="110"></af-table-column>
            <af-table-column prop="orderSourcemean" label="建单来源" min-width="160" show-overflow-tooltip></af-table-column>
            <af-table-column prop="orderTypemean" label="单据类型" min-width="70" show-overflow-tooltip></af-table-column>
            <af-table-column prop="statusmean" label="状态" min-width="100" show-overflow-tooltip></af-table-column>
            <el-table-column label="操作" min-width="260" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button type="primary"
                    @click="productlistform.orderNum = props.row.orderNum, productinfo(props.row)">产品明细
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"></el-pagination>
        </el-col>
      </el-row>

      <el-dialog title="产品明细" :visible.sync="productVisible" width="75%">
        <span>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="productlist" style="width:100%;"
            id="parent">
            <af-table-column prop="orderNum" label="退货单号" min-width="160" show-overflow-tooltip></af-table-column>
            <af-table-column prop="productCode" label="产品编码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="productName" label="产品名称" min-width="110" show-overflow-tooltip></af-table-column>
           
            <af-table-column prop="planQuantity" label="计划数量" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="planUnitCode" label="单位编码(计划数量)" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="planUnitName" label="单位名称(计划数量)" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="returnQuantity" label="退货数量" min-width="100" show-overflow-tooltip></af-table-column> 
            <af-table-column prop="returnUnitCode" label="单位编码(退货数量)" min-width="110" show-overflow-tooltip></af-table-column>
            <af-table-column prop="returnUnitName" label="单位名称(退货数量)" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="createTime" label="创建时间" min-width="110"></af-table-column>
            <el-table-column label="操作" min-width="260" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button type="primary"
                    @click="codelistform.orderNum = props.row.orderNum, codelistform.productCode = props.row.productCode, codesinfo(props.row)">码列表
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <!-- <el-pagination background @current-change="currentchange2" @size-change="pagesize2"
            :current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"></el-pagination> -->
        </span>

      </el-dialog>
      <el-dialog title="码列表" :visible.sync="codesVisible" width="75%">
        <span>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="codelist" style="width:100%;"
            id="parent">
            <af-table-column prop="orderNum" label="退货单号" min-width="160" show-overflow-tooltip></af-table-column>
            <af-table-column prop="originalOutbillCode" label="原出库单" min-width="160" show-overflow-tooltip></af-table-column>
            <af-table-column prop="batchNo" label="批次号" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="productCode" label="产品编码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="productName" label="产品名称" min-width="110" show-overflow-tooltip></af-table-column>
            <af-table-column prop="unitCode" label="单位编码" min-width="110" show-overflow-tooltip></af-table-column>
            <af-table-column prop="unitName" label="单位编码" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="packageLevel" label="包装级别" min-width="220" show-overflow-tooltip></af-table-column>
            <af-table-column prop="qrcode" label="码" min-width="100" show-overflow-tooltip></af-table-column>
            <af-table-column prop="createTime" label="创建时间" min-width="110"></af-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange3" @size-change="pagesize3"
            :current-page.sync="currentPage3" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"></el-pagination>
        </span>

      </el-dialog>
    </div>
  </div>
</template>
<script>
import { productlist } from "@/api/base";
import { goodsorders, returnorderProducts, returngoodscodes } from "@/api/physical";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata(this.searchform);
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //产品列表下拉
      productVisible: false,
      codesVisible: false,
      show: false,
      productlist: [],
      codelist: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,

      total_count2: 1,
      currentPage2: 1,
      total_count3: 1,
      currentPage3: 1,
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      searchform: {
        datelist: [],
        "creatorAccount": "",
        "creatorName": "",
        "dealerCode": "",
        "dealerName": "",
        "depositPdaUser": "",
        "depositWarehouseCode": "",
        "depositWarehouseName": "",
        "freightBillCode": "",
        "limit": 10,
        "orderNum": "",
        "orderSource": 1,
        "orderType": 1,
        "originalOutbillCode": "",
        "page": 1,
        "status": null,
        "statusList": [
        ]
      },
      productlistform: {
        "freightBillCode": "",
        "limit": 10,
        "orderNum": '',
        "originalOutbillCode": "",
        "page": 1,
      },
      codelistform: {
        "batchNo": "",
        "freightBillCode": "",
        "limit": 10,
        "orderNum": "",
        "page": 1,
        "productCode": "",
        "productName": "",
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      obj.startTime = this.searchform.datelist.length ? this.searchform.datelist[0] : '';
      obj.endTime = this.searchform.datelist.length ? this.searchform.datelist[1] : '';
      goodsorders(obj).then(response => {
        this.getdate(response.data.list)
        this.tableData = response.data.list;
        // this.currentPage = response.data.page;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    getdate(obj) { // 拼装后台传的表格数据
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].orderType) {
          case 1: obj[i].orderTypemean = "销售退货"
            break;
          case 2: obj[i].orderTypemean = "拒收退货"
            break;
          default:
            break;
        };
        switch (obj[i].orderSource) {
          case 0: obj[i].orderSourcemean = "系统建单"
            break;
          case 1: obj[i].orderSourcemean = "其他系统推送"
            break;
          default:
            break;
        };
        switch (obj[i].status) {
          case 0: obj[i].statusmean = "未处理"
            break;
          case 1: obj[i].statusmean = "处理中"
            break;
          case 2: obj[i].statusmean = "已处理"
            break;
          default:
            break;
        };
      }
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page
      this.Tabledata(this.searchform);
      console.log(page)
    },
    //分页每页显示条数事件
    pagesize(limit) {
      this.searchform.limit = limit
      this.search()
    },

    productinfo(row) {
      this.listLoading = true;
      returnorderProducts(this.productlistform).then(response => {
        this.listLoading = false;
        this.productlist = response.data;
        this.productVisible = true;
        console.log(response.data)
      })
    },
    //分页跳转事件
    // currentchange2(page) {
    //   this.productlistform.page = page
    //   this.productinfo();
    //   console.log(page)
    // },
    // //分页每页显示条数事件
    // pagesize2(limit) {
    //   this.productlistform.limit = limit
    //   this.productinfo();
    // },
    codesinfo(row) {
      this.listLoading = true;
      returngoodscodes(this.codelistform).then(response => {
        this.listLoading = false;
        this.codelist = response.data.list;
        this.codesVisible = true;
        console.log(response.data)
      })
    },
    //分页跳转事件
    currentchange3(page) {
      this.codelistform.page = page
      this.codesinfo();
      console.log(page)
    },
    //分页每页显示条数事件
    pagesize3(limit) {
      this.codelistform.limit = limit
      this.codesinfo();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        limit: this.total_count,
        rejected_orderno: this.searchform.rejected_orderno,
        batch_no: this.searchform.batch_no,
        outbill_code: this.searchform.outbill_code,
        qrcode: this.searchform.qrcode,
        freightBillCode: this.searchform.freightBillCode,
        screate_time: this.searchform.datelist == null ? null : this.searchform.datelist[0],
        ecreate_time: this.searchform.datelist == null ? null : this.searchform.datelist[1],
        packageLevel: this.searchform.packageLevel,
        productCode: this.searchform.productCode,
        channelType: 1,
      };
      goodsorders(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.getdate(this.tableDataDownload)
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "退货单号",
            "运单号",
            "出库单号",
            "批次号",
            "客户",
            "产品",
            "箱码/盒码",
            "包装级别",
            "扫码时间",
            "退货时间",

            "退货数量",
            "退货渠道",
            "退货类型"
          ];
          const filterVal = [
            "rejected_orderno",
            "freight_bill_code",
            "outbill_code",
            "batch_no",
            "dealer",
            "product",
            "qrcode",
            "package_level",
            "scan_time",
            "create_time",

            "packing_proportion",
            "channel_type",
            "rejected_order_type"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>